import produce from 'immer';
import { ReportRequest } from './Report.model';
import moment from 'moment';

export const serializeReportSpec = (reportSpec: ReportRequest) => {
  return produce(reportSpec, (draft) => {
    // parse to 2025-08-05 11:42:07 CEST
    draft.timeRange.from = serializeDate(draft.timeRange.from);
    draft.timeRange.to = serializeDate(draft.timeRange.to);
  });
};

export const serializeDate = (date: moment.MomentInput) =>
  moment(date).format('YYYY-MM-DD HH:mm:ss Z');
